module.exports = __webpack_public_path__ + "static/media/swords-pavilions.d5b89618.png";